<div class="pg-content__inner-transparent">
  <div class="sign-oauth__loading">
    <div class="ui-loader ui-loader__page-dark"></div>
  </div>
</div>
